import { render } from "./ProjectDetailsInvitations.vue?vue&type=template&id=282be7be&scoped=true"
import script from "./ProjectDetailsInvitations.vue?vue&type=script&lang=js"
export * from "./ProjectDetailsInvitations.vue?vue&type=script&lang=js"

import "./ProjectDetailsInvitations.vue?vue&type=style&index=0&id=282be7be&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-282be7be"]])

export default __exports__